import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { useState } from 'react';

export const useTaskModalState = (tasks: AutopilotTaskDto[]) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openTasks, setOpenTasks] = useState(tasks);

  const open = (currentTasks: AutopilotTaskDto[]) => {
    setOpenTasks(currentTasks);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    close,
    isOpen,
    modalTasks: isOpen ? openTasks : tasks,
    open,
  };
};
